import { useRouteHistoryStore } from "@/stores/route-history.store";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import posthog from "posthog-js";
import { useRuntimeConfig } from "./useRuntimeConfig";

// Track whether PostHog has been initialized
let posthogInitialized = false;

export function useRouteTracker() {
  const router = useRouter();
  const routeHistoryStore = useRouteHistoryStore();
  const { config } = useRuntimeConfig();
  const [ready, setReady] = useState(posthogInitialized);

  // Lazy initialization of PostHog using runtime config
  useEffect(() => {
    if (typeof window !== "undefined" && config && !posthogInitialized) {
      posthog.init(config.posthog.key || "", {
        api_host: config.posthog.host || "/ingest",
        ui_host: "https://us.posthog.com",
        // Enable debug mode in development
        loaded: (posthog) => {
          if (process.env.NODE_ENV === "development") posthog.debug();
        },
      });
      posthogInitialized = true;
      setReady(true);
    }
  }, [config]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("initialReferrer");
      const extractDomain = (url: any) => {
        try {
          const hostname = new URL(url).hostname;
          const match = hostname.match(/(?:www\.)?(?:l\.)?([^\.]+)\.\w+$/);
          return match
            ? match[1].charAt(0).toUpperCase() + match[1].slice(1)
            : "";
        } catch (e) {
          console.error("Error extracting domain: ", e);
          return "";
        }
      };
      const referrer = document.referrer;
      if (referrer) {
        const capitalizedDomain = extractDomain(referrer);
        if (
          capitalizedDomain !== "Padev" &&
          capitalizedDomain !== "Privateauto"
        ) {
          localStorage.setItem("initialReferrer", capitalizedDomain);
        }
      }
    }
  }, []);
  useEffect(() => {
    // Only set up tracking if PostHog is ready
    if (!ready) return;

    const handleRouteChange = () => {
      posthog?.capture("$pageview");
    };
    const onRouteChangeStart = () => {
      routeHistoryStore.registerRoute(router.asPath);
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    router.events.on("routeChangeStart", onRouteChangeStart);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
      router.events.off("routeChangeStart", onRouteChangeStart);
    };
  }, [router, ready, routeHistoryStore]);
}
